import { render, staticRenderFns } from "./VehiclePanel.vue?vue&type=template&id=50b9bc4d&scoped=true"
import script from "./VehiclePanel.vue?vue&type=script&lang=js"
export * from "./VehiclePanel.vue?vue&type=script&lang=js"
import style0 from "./VehiclePanel.vue?vue&type=style&index=0&id=50b9bc4d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b9bc4d",
  null
  
)

export default component.exports